const e = {
  add: "Ajouter",
  cancel: "Annuler",
  clear: "Effacer",
  confirm: "Confirmer",
  delete: "Supprimer",
  redo: "Restaurer",
  save: "Sauvegarder",
  saveAs: "Enregistrer sous",
  undo: "Annuler"
}, o = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, n = {
  cancel: "Annuler",
  confirm: "Confirmer",
  datePlaceholder: "Sélectionner la date",
  datetimePlaceholder: "Sélectionnez la date et l'heure",
  endDatePlaceholder: "Date de fin",
  endDatetimePlaceholder: "Date et heure de fin",
  endMonthPlaceholder: "Mois de fin",
  monthPlaceholder: "Sélectionner un mois",
  now: "Maintenant",
  quarterPlaceholder: "Sélectionner le trimestre",
  selectDate: "Sélectionner la date",
  selectTime: "Sélectionner l'heure",
  startDatePlaceholder: "Date de début",
  startDatetimePlaceholder: "Date et heure de début",
  startMonthPlaceholder: "Mois de début",
  today: "Aujourd'hui",
  weekPlaceholder: "Sélectionner la semaine",
  yearPlaceholder: "Sélectionnez l'année",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, r = {
  placeholder: "Veuillez sélectionner"
}, t = {
  clear: "Effacer",
  negativeText: "Annuler",
  now: "Maintenant",
  placeholder: "Sélectionner l'heure",
  positiveText: "OK"
}, a = {
  placeholder: "Veuillez saisir"
}, l = {
  placeholder: "Veuillez saisir"
}, s = {
  placeholder: "Commencez la saisie..."
}, c = {
  allRows: "Toutes les lignes",
  default: "Par défaut",
  deleteLayoutDescription: "Voulez-vous vraiment supprimer cette mise en page ?",
  discardChanges: "Ignorer les modifications",
  discardLayoutChanges: "Ignorer les modifications d'alignement du contenu",
  enterLayoutName: "Entrer le nom de la mise en page",
  enterRowNumber: "Entrer le nombre de lignes",
  fieldsSelected: "champs sélectionnés",
  freezeColumnDescription: "Figez la colonne à gauche",
  freezeUptoColumn: "Figez jusqu'à la colonne",
  frozen: "Gelé",
  layoutName: "Nom de la mise en page",
  manageColumns: "Gérer les colonnes",
  none: "Aucune",
  reorderRows: "Réorganiser les lignes",
  rowsSelected: "Lignes sélectionnées",
  saveLayoutAs: "Enregistrer la mise en page comme",
  saveLayoutNew: "Enregistrer la nouvelle mise en page",
  search: "Rechercher",
  searchColumnsPlaceholder: "Rechercher des colonnes",
  searchFieldsPlaceholder: "Champs de recherche",
  selectAll: "Sélectionner tout",
  setTableHeight: "Définir la hauteur du tableau",
  unfreeze: "Dégeler",
  unsavedChanges: "Toutes les modifications n'ont pas été enregistrées",
  unsavedChangesDescription: "Il peut y avoir une ou plusieurs modifications non enregistrées. Souhaitez-vous les enregistrer ?"
}, i = {
  at: "à",
  colorAlreadyUsed: "Sélectionnez une couleur différente ou utilisez une couleur en cours",
  colorNamePlaceholder: "Saisir le nom",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Veuillez choisir un autre nom de couleur.",
  noColorsAdded: "Vous n'avez aucune couleur dans cette section."
}, u = {
  searchPlaceholder: "Rechercher"
}, d = {
  invalidPastedData: "Données collées non valides"
}, p = {
  of: "de",
  page: "Page",
  rowsPerPage: "Lignes par page"
}, h = {
  failedToUpload: "Échec du téléchargement",
  retry: "Réessayer",
  clickToUpload: "contact pour télécharger",
  orDragAndDrop: "ou pour supprimer",
  supportedFileTypes: "Types de fichier pris en charge :"
}, m = {
  global: e,
  Progress: o,
  DatePicker: n,
  Select: r,
  TimePicker: t,
  Input: a,
  InputNumber: l,
  InputTag: s,
  HLDataTable: c,
  ColorPicker: i,
  InputPhone: u,
  InputOtp: d,
  Pagination: p,
  Upload: h
};
export {
  i as ColorPicker,
  n as DatePicker,
  c as HLDataTable,
  a as Input,
  l as InputNumber,
  d as InputOtp,
  u as InputPhone,
  s as InputTag,
  p as Pagination,
  o as Progress,
  r as Select,
  t as TimePicker,
  h as Upload,
  m as default,
  e as global
};
